var _path, _path2, _path3, _path4, _linearGradient, _path5, _linearGradient2, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Skrill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#970E76",
    d: "M21,1H3C1.8969727,1,1,1.8969727,1,3v18c0,1.1030273,0.8969727,2,2,2h18c1.1030273,0,2-0.8969727,2-2V3 C23,1.8969727,22.1030273,1,21,1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M21,1H3C1.8969727,1,1,1.8969727,1,3v0.25c0-1.1030273,0.8969727-2,2-2h18 c1.1030273,0,2,0.8969727,2,2V3C23,1.8969727,22.1030273,1,21,1z",
    opacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21,22.75H3c-1.1030273,0-2-0.8969727-2-2V21c0,1.1030273,0.8969727,2,2,2h18c1.1030273,0,2-0.8969727,2-2 v-0.25C23,21.8530273,22.1030273,22.75,21,22.75z",
    opacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    d: "M13.5,10C11,10,11,9.2475586,11,9s0-1,1.5-1c1.5410156,0,4.3071289,0.9624023,4.3349609,0.9716797 L17.5,9.2045898V5.1777344l-0.2939453-0.1333008C17.1118164,5.0019531,14.8666992,4,12,4C9.0913086,4,6,5.7524414,6,9 c0,3.6425781,3.3735352,5,5.5,5c1.5,0,1.5,0.675293,1.5,1c0,0.5795898-0.6308594,1-1.5,1 c-0.887207,0-3.8193359-0.7104492-4.8745117-0.9838867L6,14.8535156v3.9511719l0.2705078,0.1396484 C6.3540039,18.9873047,8.3520508,20,11.5,20c3.9487305,0,6.5-1.9624023,6.5-5C18,11.7172852,15.7363281,10,13.5,10z"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bZkz66EEvFbQfHQksqCCQa",
    x1: 9.675,
    x2: 22.293,
    y1: 9.916,
    y2: 22.534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bZkz66EEvFbQfHQksqCCQa)",
    d: "M17.5,5.1777344v4.0268555l-0.6650391-0.2329102C16.8071289,8.9624023,14.0410156,8,12.5,8 C11,8,11,8.7524414,11,9s0,1,2.5,1c2.2363281,0,4.5,1.7172852,4.5,5c0,3.0375977-2.5512695,5-6.5,5 c-3.1479492,0-5.1459961-1.0126953-5.2294922-1.0556641L6,18.8046875L10.1953125,23H21c1.1030273,0,2-0.8969727,2-2V10.6776733 L17.5,5.1777344z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bZkz66EEvFbQfHQksqCCQb",
    x1: -0.652,
    x2: 24.652,
    y1: 6.1,
    y2: 17.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bZkz66EEvFbQfHQksqCCQb)",
    d: "M21,1H3C1.8969727,1,1,1.8969727,1,3v18c0,1.1030273,0.8969727,2,2,2h18 c1.1030273,0,2-0.8969727,2-2V3C23,1.8969727,22.1030273,1,21,1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Skrill);
export default __webpack_public_path__ + "static/media/icons8-skrill.501ce8b8e22da37bc3ec778682d46576.svg";
export { ForwardRef as ReactComponent };